export default function campaignSettings (Restangular) {
  'ngInject'
  return Restangular.all('campaign/portal-settings')
}
